import productPriceHtml from '../views/productPrice.component.html';

class ProductPriceController {
    constructor($scope, $attrs) {
        'ngInject';

        this.total = false;
    }

    $onInit() {
    }

    getNet() {
        // console.log(this.price);
        // this.price.getNet() }} G: {{ $ctrl.totalPrice.price.getGross() }}, {{ $ctrl.totalPrice.price.getNetFormatted() }}
        //const price = this.total ? this.price.price_total : this.price.price;
        // return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: this.price.currency.iso_code}).format(price);
        return 'a';
    }

    getGross() {
        return 'b';
        const price = (this.total ? this.price.price_total : this.price.price) * this.price.tax_rate;
        return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: this.price.currency.iso_code}).format(price);
    }
}

let productPriceComponent = {
    bindings: {
        price: '<',
        total: '<'
    },
    template: productPriceHtml,
    controller: ProductPriceController
}

export default productPriceComponent;
